import { K8sProviderIcon } from '@cast/features-cluster-ui';

import { CAST_AI } from '@cast/constants';
import {
  Button,
  DialogContent,
  DialogFooter,
  Typography,
  Stack,
} from '@cast/design-system';
import { Cluster } from '@cast/types';

import {
  ClusterDialogTitle,
  DialogHeading,
  StepContainer,
} from 'hooks/dialogs/cluster/_components/new-onboarding';

type Props = {
  cluster: Cluster;
  onClose: () => void;
};

export const SuccessStep = ({ cluster, onClose }: Props) => {
  return (
    <StepContainer data-testid="castctl-success-step">
      <DialogHeading onClose={onClose} hideTerraformLink>
        <Stack>
          <ClusterDialogTitle>
            Cluster is now connected to {CAST_AI}
          </ClusterDialogTitle>
          <Stack direction="row" alignItems="center" gap={4} flexWrap="nowrap">
            <K8sProviderIcon provider={cluster.providerType} size={14} />
            <Typography variant="A1" color="textSecondary">
              {cluster.name}
            </Typography>
          </Stack>
        </Stack>
      </DialogHeading>

      <DialogContent>
        <Stack gap={8}>
          <Typography variant="h5"></Typography>

          <Typography variant="P12R">
            Setup may still be in progress. Follow the remaining instructions in
            your terminal to complete the setup.
          </Typography>
        </Stack>
      </DialogContent>

      <DialogFooter
        sx={{ border: 'none' }}
        end={
          <Button onClick={onClose} testId="castctl-success-close-button">
            Close
          </Button>
        }
      />
    </StepContainer>
  );
};
